(function () {
  'use strict';

  angular.module('sempraWebapp').factory('userRolesEnum', userRolesFactory);

  function userRolesFactory () {
    return Object.freeze({
      CONSUMER: 'CONSUMER',
      SUBSCRIBER: 'SUBSCRIBER',
      SYSTEM_ADMIN: 'SYSTEM_ADMIN',
      MERCHANT_ADMIN: 'MERCHANT_ADMIN',
      COMPANY_ADMIN: 'COMPANY_ADMIN',
      FACILITY_ADMIN: 'FACILITY_ADMIN',
      CONTROLLER: 'CONTROLLER',
      TECHNICAL_SUPPORT: 'TECHNICAL_SUPPORT',
      ADMINISTRATOR: 'ADMINISTRATOR'
    });
  }
})();
